import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import App from './App';
import Work from './Work';
import sideProjects from './SideProjects';
import tese from './Tese';
import resume from './Resume';

// import NotFound from './NotFound';

const Routers = () => (
    <Router>
        <Switch>
             <Route exact path="/" component={App} />
             <Route path="/works/:id" component={Work} />
             <Route path="/sideprojects/:id" component={sideProjects} />
             <Route path="/tese" component={tese} />
             <Route path="/resume" component={resume} />
             {/* quando nao tem path vai para 404 */}
             {/* <Route exact component={NotFound} /> */}
        </Switch>
    </Router>
)

export default Routers
